import React from 'react';
import { Box, Typography } from '@mui/material';

interface RegimeBadgeProps {
  regimeChanged: boolean;
  changeStrength: 'Faible' | 'Modéré' | 'Fort';
  explanation: string;
}

const badgeColors = {
  Faible: { background: 'rgba(109, 126, 132, 0.12)', color: '#556970' },
  Modéré: { background: 'rgba(141, 108, 22, 0.14)', color: '#8d6c16' },
  Fort: { background: 'rgba(170, 61, 51, 0.14)', color: '#aa3d33' },
};

export const RegimeBadge: React.FC<RegimeBadgeProps> = ({ regimeChanged, changeStrength, explanation }) => {
  if (!regimeChanged) return null;
  const palette = badgeColors[changeStrength];

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 1.1,
        px: 1.7,
        py: 1.05,
        borderRadius: 3.5,
        background: palette.background,
        color: palette.color,
        border: '1px solid rgba(16,37,43,0.08)',
        boxShadow: '0 10px 24px rgba(16,37,43,0.06)',
        maxWidth: '100%',
      }}
      title={explanation || 'Le marché montre une évolution significative de la dominance sur les 7 derniers jours.'}
    >
      <Box sx={{ fontSize: 20, lineHeight: 1 }}>↻</Box>
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="body2" sx={{ fontWeight: 800, color: palette.color }}>
          Changement de régime détecté
        </Typography>
        <Typography variant="caption" sx={{ color: '#556970' }}>
          Intensité {changeStrength}.
        </Typography>
      </Box>
    </Box>
  );
};

export default RegimeBadge;
